import { Suspense, useEffect } from 'react';
import { HashRouter, Navigate, Route, Routes } from 'react-router-dom';
import { getStrapiContent } from '../store/actions/contentAction';
import { useDispatch } from 'react-redux';
import { CircularProgress } from '@mui/material';
import ErrorModal from '../components/Modals/ErrorModal';
import { getConfigurationSettings } from '../store/actions/authActions';
import {
  ChooseInvestorType,
  CorporateForm,
  CreateAccount,
  NafathVerification,
  OtpVerification,
  ProgressSaved,
  SubmitApplication,
  Welcome,
} from '../pages';

const Router = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const getContent = async () => {
      dispatch(getStrapiContent());
    };
    dispatch(getConfigurationSettings());
    getContent();
  }, []);

  const indicatorSize = 80;

  return (
    <HashRouter>
      <div>
        <Suspense
          fallback={
            <CircularProgress
              size={indicatorSize}
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                marginTop: `${-indicatorSize / 2}px`,
                marginLeft: `${-indicatorSize / 2}px`,
              }}
            />
          }
        >
          <Routes>
            <Route path='/' element={<Navigate to='/welcome' replace />} />
            <Route path='*' element={<Navigate to='/welcome' replace />} />
            <Route path={'/welcome'} Component={Welcome} />
            <Route path={'/choose-investor-type'} Component={ChooseInvestorType} />
            <Route path={'/create-corporate-account'} Component={CreateAccount} />
            <Route path={'/otp-verification'} Component={OtpVerification} />
            <Route path={'/nafath-verification'} Component={NafathVerification} />
            <Route path={'/corporate-form'} Component={CorporateForm} />
            <Route path={'/submit-application'} Component={SubmitApplication} />
            <Route path={'/progress-saved'} Component={ProgressSaved} />
          </Routes>
        </Suspense>

        <ErrorModal />
      </div>
    </HashRouter>
  );
};

export default Router;
